// extracted by mini-css-extract-plugin
export default {"backToResult":"BackToResut_backToResult__38Byl","backToResult_text":"BackToResut_backToResult_text__WCV5V"};